import React from "react";

import { isEmpty } from "ramda";

import { Pagination, Table as CSTable } from "clearsense-ui/components";
import NoData from "components/Common/NoData";

import { COLUMN_DATA } from "./columns";

import { MINIMUM_PAGE_SIZE, PAGE_SIZE_INCREMENT } from "../constants";

const Table = ({
  analyses,
  currentPage,
  setCurrentPage,
  pageSize,
  setPageSize,
  debouncedSearchTerm,
  setIsNewPaneOpen,
}) => {
  if (!analyses?.count && isEmpty(debouncedSearchTerm)) {
    return (
      <NoData
        entity="analyses"
        actionLabel="Create Analysis"
        onAction={() => setIsNewPaneOpen(true)}
      />
    );
  }

  return (
    <div className="cs-ui-table-background">
      <CSTable
        columnData={COLUMN_DATA}
        rowKey={record => record.id}
        rowData={analyses?.data}
        allowRowClick={false}
        data-cy="analysis-table"
      />
      {analyses?.count > pageSize && (
        <Pagination
          className="p-6 m-0"
          totalRecordsCount={analyses?.count}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          pageSize={pageSize}
          showResultsPerPage
          setPageSize={setPageSize}
          pageSizeOptionsList={Array.from(
            { length: MINIMUM_PAGE_SIZE },
            (_, index) => index + PAGE_SIZE_INCREMENT
          )}
        />
      )}
    </div>
  );
};

export default Table;
